import Button from '../buttons/defaultButton';
import Container from '../../atoms/container/modalButtons';
import Direction from '../../../../shared/types/enums/direction';
import Focus from '../../../../shared/types/enums/focus';
import List from '../../sections/list/list';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import { GenericModalProps as Props } from '../../../../shared/types/props/modal';
import { clearModal } from '../../../../shared/store/slices/modal.slice';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useEffect } from 'react';

function GenericAcceptModalButtons({
  acceptAction,
  cancelAction,
  allowedBack = true,
  acceptButtonText = 'MODAL.GENERIC_ACCEPT_BUTTONS.YES',
  cancelButtonText = 'MODAL.GENERIC_ACCEPT_BUTTONS.NO',
}: Props) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  useKeyboard({
    focus: Focus.MODAL_BUTTONS,
    stopPropagation: true,
    keyDownHandler: () => null,
    keyUpHandler: (key) => {
      if (key === 'BACK' && allowedBack) {
        dispatch(clearModal());
      }
    },
  });

  return (
    <Container>
      <List direction={Direction.VERTICAL} focus={Focus.MODAL_BUTTONS}>
        <Button
          index={0}
          text={acceptButtonText}
          releaseAction={() => {
            dispatch(clearModal());
            acceptAction && acceptAction();
          }}
        />
        <Button
          index={1}
          text={cancelButtonText}
          releaseAction={() => {
            dispatch(clearModal());
            cancelAction && cancelAction();
          }}
        />
      </List>
    </Container>
  );
}

export default GenericAcceptModalButtons;
